import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'm-complex-input',
  template: `
    <div class="m-complex-input-handler-wrap">
      <span
        class="m-complex-input-handler"
        (click)="onUpClick($event)"
        [class.m-complex-input-handler-up-disabled]="mDisabledUp && mDisabledUp()"
      >
        <i nz-icon nzType="caret-up" nzTheme="outline"></i>
      </span>
      <span
        class="m-complex-input-handler down"
        (click)="onDownClick($event)"
        [class.m-complex-input-handler-down-disabled]="mDisabledDown && mDisabledDown()"
      >
        <i nz-icon nzType="caret-down" nzTheme="outline"></i>
      </span>
    </div>
    <div class="m-complex-input-handler-prefix" *ngIf="mShowSearchIcon">
      <i nz-icon>
        <svg
          t="1630049398692"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1946"
          width="16"
          height="16"
        >
          <path
            d="M437.504 56.32c206.272 0 373.504 169.6 373.504 378.752a380.48 380.48 0 0 1-88.32 244.608l70.4 71.424a60.992 60.992 0 0 1 59.904 16l88.96 90.304c24.064 24.384 24 64 0 88.32l-0.96 1.024a60.928 60.928 0 0 1-87.04 0l-89.024-90.304a63.04 63.04 0 0 1-15.808-60.672l-70.4-71.488a368.896 368.896 0 0 1-241.216 89.6C231.232 813.888 64 644.288 64 435.072 64 225.92 231.232 56.32 437.504 56.32z m0 63.104C265.6 119.424 126.272 260.736 126.272 435.072S265.6 750.72 437.504 750.72c171.904 0 311.232-141.312 311.232-315.648S609.408 119.424 437.504 119.424z"
            fill="#41464B"
            fill-opacity=".9"
            p-id="1947"
          ></path>
        </svg>
      </i>
    </div>
    <input
      class="m-complex-input-block"
      [ngModel]="inputValue"
      (keyup.enter)="mInputChange.emit(inputValue)"
      (ngModelChange)="onModelChange($event)"
      [ngStyle]="{ paddingLeft: mShowSearchIcon ? '24px' : '0' }"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'm-complex-input'
  }
})
export class MComplexInputComponent implements OnInit, OnDestroy {
  @Input() mShowSearchIcon: boolean = true;
  @Input() mDisabledUp?: () => boolean;
  @Input() mDisabledDown?: () => boolean;

  @Output() readonly mUpChange = new EventEmitter<void>();
  @Output() readonly mDownChange = new EventEmitter<void>();
  @Output() readonly mInputChange = new EventEmitter<string>();

  inputValue: string = '';
  destroy$ = new Subject<void>();
  inputChangeValue$ = new Subject<string>();

  ngOnInit(): void {
    this.inputChangeValue$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(res => {
      this.inputValue = res;
    });
  }
  onModelChange(value: string): void {
    this.inputChangeValue$.next(value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDownClick(event: MouseEvent): void {
    if (this.mDisabledDown && this.mDisabledDown()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    } else {
      this.mDownChange.emit();
    }
  }

  onUpClick(event: MouseEvent): void {
    if (this.mDisabledUp && this.mDisabledUp()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    } else {
      this.mUpChange.emit();
    }
  }
}
